import { 
  SET_SCAN_BY_ID, 
  IS_SCAN_SAVED, 
  IS_SCAN_UPDATED,
  SET_ALL_SCANS,
  SET_FILTERS,
  SET_PAGINATION_DATA,
  SET_SCANS_EXCEL_EXPORT_FILE,
  SET_TEMPLATE_DATA,
  IS_ASSETS_UPLOADED
} from './MandAScanTypes'
const initialState = {
   scanById : {},
   isScanSavedFlag: {},
   isScanUpdatedFlag: {},
   allScans: {},
   filters: {},
   paginationData: {}
}

const mergerAndAquisitionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_SCAN_BY_ID:
      return {
        ...state,
        scanById: action.scanById,
      }
    case IS_SCAN_SAVED:
      return {
        ...state,
        isScanSavedFlag: action.flag,
      }
    case IS_SCAN_UPDATED:
      return {
        ...state,
        isScanUpdatedFlag: action.flag,
      }
    case SET_ALL_SCANS:
      return {
        ...state,
        allScans: action.allScans,
      }
    case SET_FILTERS:
      return {
        ...state,
        filters: {...state?.filters, ...action.filters},
      }
    case SET_PAGINATION_DATA:
      return {
        ...state,
        paginationData: action.paginationData,
      }
    case SET_SCANS_EXCEL_EXPORT_FILE:
      return {
        ...state,
        scansExcelExportFile: action.file,
      }
    case SET_TEMPLATE_DATA:
      return {
        ...state,
        template: action.file,
      }
    case IS_ASSETS_UPLOADED:
      return {
        ...state,
        isAssetsUploaded: action.flag,
      }
    default: return state
  }
}

export default mergerAndAquisitionReducer
